import { render, staticRenderFns } from "./elitigation-sessions.vue?vue&type=template&id=50d37b94&"
import script from "./elitigation-sessions.vue?vue&type=script&lang=js&"
export * from "./elitigation-sessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports